export class DrawingEngine {

  LineWidth = 0.5;

  constructor() {
    this.activePoints = [];
  }

  // Apply transformation to context
  applyTransform(ctx, transform) {
    ctx.setTransform(1, 0, 0, 1, 0, 0); // Reset transformation
    ctx.translate(transform.translateX, transform.translateY);
    ctx.scale(transform.scale, transform.scale);
  }


  drawGrid(ctx, gridOffset, gridWidth, gridHeight, spacing, scale) {

    ctx.save();
    ctx.translate(gridOffset.x, gridOffset.y);

    ctx.beginPath();
    ctx.strokeStyle = '#d3d3d3';
    ctx.lineWidth = 0.5 / scale;

    for (let x = 0; x <= gridWidth; x += spacing) {
      ctx.moveTo(x, 0);
      ctx.lineTo(x, gridHeight);
    }
    for (let y = 0; y <= gridHeight; y += spacing) {
      ctx.moveTo(0, y);
      ctx.lineTo(gridWidth, y);
    }
    ctx.stroke();
    ctx.restore();
  }


  drawBackground(ctx, gridOffset, gridWidth, gridHeight, spacing, scale) {
    ctx.save();
    ctx.translate(gridOffset.x, gridOffset.y);
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, gridWidth, gridHeight);

    // Draw border around grid
    ctx.strokeStyle = '#333';
    ctx.lineWidth = 2 / scale;
    ctx.strokeRect(0, 0, gridWidth, gridHeight);
    ctx.restore();
  }

}
